import {
  Description,
  Divider,
  PrivacyTermsAppWrapper,
  Title,
} from 'components/terms/Terms.styled';

export const THIRD_PARTY_PRIVACY_TERMS_HISTORY: Record<string, JSX.Element> = {
  '': (
    <PrivacyTermsAppWrapper>
      <Title>[필수] 개인정보 제3자 제공 동의</Title>
      <Description>
        회사는 네이버페이 포인트 전환 처리 및 적립을 위해 다음과 같이 귀하의
        개인정보를 제3자에게 제공합니다.
      </Description>
      <Divider />
      <p>제공받는 자</p>
      <b>(주)다우기술</b>
      <br />
      <br />
      <p>제공 항목</p>
      <p>
        네이버페이 회원 키(userKey), 전환할 포인트 금액(point), 오베이-다우 간
        거래번호
      </p>
      <br />
      <br />
      <p>제공 목적</p>
      <ul style={{ listStyle: 'inside' }}>
        <li>
          <b>네이버페이 포인트 적립 처리</b>
        </li>
        <li>
          <b>전환 거래 확인 및 정산</b>
        </li>
      </ul>
      <br />
      <br />

      <p>보유 및 이용 기간</p>
      <ul style={{ listStyle: 'inside' }}>
        <li>
          <b>
            수집된 정보는 전환 요청 처리 및 사용자 식별을 위해 일시적으로
            사용되며, 처리 완료 시 즉시 파기
          </b>
        </li>
      </ul>
      <Description>
        <p>동의를 거부할 권리 및 불이익 안내</p>
        <ul style={{ listStyle: 'inside' }}>
          <li>
            제3자 제공에 동의하지 않으실 경우, 네이버페이 포인트 전환 서비스를
            이용하실 수 없습니다.
          </li>
        </ul>
      </Description>
    </PrivacyTermsAppWrapper>
  ),
};
